import ArtikelUmbuchenController from './../controllers/artikelUmbuchen.controller';

const ArtikelUmbuchenComponent = {
    templateUrl: 'components/transportauftrag/views/artikelUmbuchen.html',
    controller: ArtikelUmbuchenController,
    bindings: {
        $router: '<'
    }
};

export default ArtikelUmbuchenComponent;
